import { render, staticRenderFns } from "./DaftarSurat.vue?vue&type=template&id=326bcab6&"
import script from "./DaftarSurat.vue?vue&type=script&lang=js&"
export * from "./DaftarSurat.vue?vue&type=script&lang=js&"
import style0 from "./DaftarSurat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports